import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './AuthContext';
import { CustomThemeProvider } from './ThemeContext';
import { VoiceProvider } from './VoiceContext';
import { LangProvider } from './i18n';
import { BugReportProvider } from './components/BugReport';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CustomThemeProvider>
      <LangProvider>
        <AuthProvider>
          <VoiceProvider>
            <BugReportProvider>
              <App />
            </BugReportProvider>
          </VoiceProvider>
        </AuthProvider>
      </LangProvider>
    </CustomThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
